import OmniApiClient from "./base";

const RESOURCE = "/sellerlogic/credentials";

export default {
  // Get all credentials
  getAll(params) {
    return OmniApiClient.get(`${RESOURCE}/`, { params });
  },

  // Get credential by ID
  get(id) {
    return OmniApiClient.get(`${RESOURCE}/${id}`);
  },

  // Create new credential
  create(data) {
    return OmniApiClient.post(`${RESOURCE}/`, data);
  },

  // Update credential
  update(id, data) {
    return OmniApiClient.put(`${RESOURCE}/${id}`, data);
  },

  // Delete credential
  delete(id) {
    return OmniApiClient.delete(`${RESOURCE}/${id}`);
  },

  // Toggle active status
  toggleActive(id) {
    return OmniApiClient.post(`${RESOURCE}/${id}/toggle-active`);
  },

  // Test API credentials without saving
  testKey(data) {
    return OmniApiClient.post(`${RESOURCE}/test-key`, data);
  },

  // Test saved credential
  test(id) {
    return OmniApiClient.post(`${RESOURCE}/${id}/test`);
  },
};
